exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AgreementRenewalRequest_component_1ZdN {\n  margin-bottom: 20px;\n\n  width: 100%;\n  max-width: none;\n\n  text-align: left\n}\n\n.AgreementRenewalRequest_component_1ZdN:last-child {\n  margin-bottom: 0;\n}\n\n.AgreementRenewalRequest_row_214b + .AgreementRenewalRequest_row_214b {\n  margin-top: 25px;\n}\n\n.AgreementRenewalRequest_checkbox_2kC9 > span {\n  top: 3px;\n}\n\n.AgreementRenewalRequest_offerText_2k3W {\n  text-align: left;\n}\n\n.AgreementRenewalRequest_button_2qLu {\n  margin-right: 20px;\n}\n", ""]);

// exports
exports.locals = {
	"component": "AgreementRenewalRequest_component_1ZdN",
	"row": "AgreementRenewalRequest_row_214b",
	"checkbox": "AgreementRenewalRequest_checkbox_2kC9",
	"offerText": "AgreementRenewalRequest_offerText_2k3W",
	"button": "AgreementRenewalRequest_button_2qLu"
};